import { computed, Signal } from "@angular/core";
import { IpSubscriptionDetails } from "../../types";
import { SubscriptionDetailTab } from "../../../../components/subscription-detail/page-tab/tab-types";
import { Router } from "@angular/router";

type GConstructor<T = {}> = new (...args: any[]) => T;
type IpSubscription = GConstructor<{
  router?: Router;
  _subscriptionId: string;
  subscription: Signal<IpSubscriptionDetails>;
  productType: Signal<string>;
  productTag: Signal<string>;
  activeTab: Signal<SubscriptionDetailTab>;
}>;

export function IpSubscriptionMixin<TBase extends IpSubscription>(Base: TBase) {
  return class IpSubscriptionMixin extends Base {
    protected serviceSpeed = computed(() => this.subscription().serviceSpeed);
    protected domain = computed(() => this.subscription().domain);
    protected ipRoutingType = computed(() => this.subscription().ipRoutingType);
    protected surfcertFilter = computed(() => this.subscription().ipss.surfcertFilter);
    protected asn = computed(() => this.subscription().ipss.asn);
    protected surfcertFilterEnabled = computed(() => this.surfcertFilter() === "enabled");
    protected topology = computed(() => this.subscription().topology);

    protected isIpBgp = computed(() => this.productTag() === "IPBGP");

    changeActiveTab(tabName: SubscriptionDetailTab) {
      this.router.navigate(["/subscription", this.productType(), this.productTag(), this._subscriptionId, tabName], {
        replaceUrl: true,
      });
    }
  };
}
